export default "__VITE_ASSET__kR9t_gfG__"